export const MIN_HEIGHT = '2em';
export const MAX_HEIGHT = '300px';
export const MAX_HEIGHT_NUMBER = 300;
export const SCROLL = 'scroll';
export const HIDDEN = 'hidden';
export const toPixels = (px: number) => (`${px}px`);
export const OFFICE_INVALID_CHARACTERS_REGEX = /\s/g;
// OGU names can contain spaces, including trailing spaces
export const ORG_OGU_INVALID_CHARACTERS_REGEX = /[\t\n\r]/g;
